import { useStoreLogger } from '@/logger.ts'
import type { ICategoryGetList, ICategoryGetListResponse, ICategoryItems, IProductGetList, IProductGetListResponse } from '@/types/CategoryTypes.ts'
import { CategoryByOrderTypeGetList, ProductByCategoryAndOrderTypeGetList } from '@/api/Category.ts'

export const CatLocalStorageKey = 'AoeCategory_'

export function SaveCategoriesToLocalStorage(orderTypeId: string, catResponse: ICategoryGetListResponse) {
  const newValue = JSON.stringify(catResponse.items)
  const logger = useStoreLogger()
  logger.debug('SaveCategoriesToLocalStorage', newValue)
  const key = CatLocalStorageKey + orderTypeId
  localStorage.setItem(key, newValue)
  window.dispatchEvent(
    new StorageEvent('storage', { key, newValue, storageArea: localStorage }),
  )
}

export async function GetCategoriesFromLocalStorageOrApi(
  request: ICategoryGetList,
): Promise<ICategoryItems[] | null> {
  const logger = useStoreLogger()
  logger.debug('GetCategoriesFromLocalStorageOrApi', request.orderTypeId)

  let cat = GetCategoryFromLocalStorage(request.orderTypeId)
  if (cat) return cat

  const catResponse = await CategoryByOrderTypeGetList(request)
  if (catResponse) {
    SaveCategoriesToLocalStorage(request.orderTypeId, catResponse)
    cat = GetCategoryFromLocalStorage(request.orderTypeId)
  }
  return cat
}

export function GetCategoryFromLocalStorage(
  orderTypeId: string,
): ICategoryItems[] | null {
  const logger = useStoreLogger()
  logger.debug('GetCartFromLocalStorage', orderTypeId)
  const key = CatLocalStorageKey + orderTypeId
  const json = localStorage.getItem(key)
  if (json) {
    logger.debug('Categories found in local storage')
    const cat: ICategoryItems[] = JSON.parse(json)
    if (cat) {
      return cat
    }
  }
  logger.debug('Categories not found in local storage')
  return null
}

export async function GetProductsByCategoryAndOrderType(
  request: IProductGetList,
): Promise<IProductGetListResponse | null> {
  const logger = useStoreLogger()
  logger.debug('GetProductsByCategoryAndOrderType', request)

  const prodResponse = await ProductByCategoryAndOrderTypeGetList(request)
  if (prodResponse) {
    return prodResponse
  }
  return null
}
